import { putTip, type TipKey } from "@serophin/nottldr-shared";
import { Lightbulb } from "lucide-preact";
import { useState } from "preact/hooks";
import { Modal } from "../Modal";

export type TipModalProps = {
  isOpen: boolean;
  tipKey: TipKey;
  title: string;
  message: string;
  onConfirm: () => void;
};

/** A one-time hint with a "don't show this again" box; what it was for happens on OK. */
export const TipModal = ({ isOpen, tipKey, title, message, onConfirm }: TipModalProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const confirm = () => {
    if (dontShowAgain) {
      void putTip(tipKey, true);
    }
    onConfirm();
  };

  return (
    <Modal isOpen={isOpen} controlledClose>
      <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center gap-2">
        <Lightbulb size={20} class="text-yellow-500" />
        {title}
      </h2>
      <p class="text-gray-600 dark:text-gray-300 mb-6">{message}</p>
      <label class="flex items-center gap-2 mb-6 cursor-pointer">
        <input
          type="checkbox"
          checked={dontShowAgain}
          onChange={(event) => setDontShowAgain(event.currentTarget.checked)}
          class="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        <span class="text-sm text-gray-600 dark:text-gray-400">Don't show this again</span>
      </label>
      <button type="button" onClick={confirm} class="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
        OK
      </button>
    </Modal>
  );
};
